// getters

const auth = state => state.auth

const isAutenticated = state => !!state.token

const authStatus = state => state.status

export default {
  auth,
  isAutenticated,
  authStatus
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js